import CryptoJS from 'crypto-js';
import type { User } from '@/types/auth';

let authToken: string | null = null;

export function setAuthToken(token: string | null): void {
  authToken = token;
}

export function getAuthToken(): string | null {
  return authToken;
}

export function createAccessToken(): string {
  const cryptoToken = import.meta.env.VITE_CRYPTO_TOKEN ?? 'betiyan-crypto-secret';
  const timestamp = Date.now().toString();
  const signature = CryptoJS.HmacSHA256(timestamp, cryptoToken).toString(CryptoJS.enc.Hex);
  return `${timestamp}.${signature}`;
}

export function normalizeUser(user: User): User {
  return {
    ...user,
    id: user.id ?? user._id,
    _id: user._id ?? user.id ?? '',
  };
}
